import { render, staticRenderFns } from "./signProduct.vue?vue&type=template&id=0e19bc04&scoped=true"
import script from "./signProduct.vue?vue&type=script&lang=js"
export * from "./signProduct.vue?vue&type=script&lang=js"
import style0 from "./signProduct.vue?vue&type=style&index=0&id=0e19bc04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e19bc04",
  null
  
)

export default component.exports